<ngx-monaco-editor
  [style.height]="height()"
  [options]="editorOptions()"
  (onInit)="onEditorInit($event)"
/>
